import { render } from "./SpeedForm.vue?vue&type=template&id=b771ff1c"
import script from "./SpeedForm.vue?vue&type=script&lang=js"
export * from "./SpeedForm.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__